import Layout from "@/views/layout";

const statistical = {
  path: "/statistical",
  name: "statistical",
  component: Layout,
  meta: { title: "销售报表" },
  children: [
    {
      path: "salesReport",
      name: "salesReport",
      component: () => import("@/views/statistical/salesReport"),
      meta: { title: "销售报表" }
    },
    {
      path: "subordinateShop",
      name: "subordinateShop",
      component: () => import("@/views/statistical/subordinateShop.vue"),
      meta: { title: "商户出库明细" }
    }
  ]
};

export default statistical;
